/// <reference path='../_references.ts'/>

module App.HeaderMessages {
	export interface GlobalMessage {
		id: number;
		message: string;
		created: string;
		visible: boolean;
		all_roles: boolean;
		roles: number[];
	}
}
